import { getCustomerPolicyTermDocumentDetails } from "../services/CustomerAPI";
import { GetCustomerDataQuery } from "../../DocuMate/model/GetCustomerDataQuery";
import { getCustomerData, getDocumentTypeList, UploadCustomerDocument } from "../../DocuMate/services/DocuMateAPI";
import { GetDocumentTypeListQuery } from "../../DocuMate/model/GetDocumentTypeListQuery";
import { UploadCustomerDocumentResponse } from "../../DocuMate/model/UploadCustomerDocumentResponse";
import * as CustomerAPI from "../services/CustomerAPI";
import { CustomerFilterViewMoel } from "../model/CustomerFilterViewModel";

class CustomerDocumentService {

    getCustomerPolicyTermDocumentDetails = async (id: string) => {
        var data = await getCustomerPolicyTermDocumentDetails(id)
        return data;
    }

    GetCustomerData = async (getCustomerDataQueryModel: GetCustomerDataQuery) => {
        var customerDataResponseDto = await getCustomerData(getCustomerDataQueryModel);
        const dataArray = [customerDataResponseDto];
        return dataArray;
    }

    getListOfDocumentType = async (getDocumentTypeListRequestModel: GetDocumentTypeListQuery) => {
        var documentTypeListResponse = await getDocumentTypeList(getDocumentTypeListRequestModel);
        let res = [];
        if (documentTypeListResponse.length > 0) {
            res = documentTypeListResponse.map((item) => ({
                value: item.id,
                label: item.type,
            }));
        }

        return res;
    }

    uploadCustomerDocument = async (
        file: File,
        payload: {
            appId: number,
            fileName: string,
            contentType: string,
            documentTypeId: string,
            indexKey1: string,
            indexKey2: string,
            attributes: string,
            userId: string
        }
    ): Promise<UploadCustomerDocumentResponse> => {
        return await UploadCustomerDocument(file, payload);
    }

    getCustomerData = async (customerId) : Promise<CustomerFilterViewMoel> => {
         let customerData = await CustomerAPI.getCustomerSummary(customerId);
         return customerData;
     }




}

  
export default CustomerDocumentService;